import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import AOS from "aos";
import "aos/dist/aos.css";
import "swiper/css";
import "swiper/css/autoplay";

// Client logos
import img1 from "../assets/Client/client-1.jpg";
import img3 from "../assets/Client/client-2.jpg";
// import img4 from "../assets/client3.png";
import img5 from "../assets/Client/client-3.jpg";
import img6 from "../assets/Client/client-4.jpg";
import img7 from "../assets/Client/client-5.jpg";
// import img8 from "../assets/client7.png";
import img9 from "../assets/Client/client-6.jpg";
import img10 from "../assets/Client/client-7.jpg";
import img11 from "../assets/Client/client-8.jpg";
import img12 from "../assets/Client/client-9.jpg";
import img13 from "../assets/Client/client-10.jpg";
import img14 from "../assets/Client/client-11.jpg";
import img15 from "../assets/Client/client-12.jpg";
import img16 from "../assets/Client/client-13.jpg";
import img17 from "../assets/Client/client-14.jpg";
import img18 from "../assets/Client/client-15.jpg";
import img19 from "../assets/Client/client-so.png";
import img2 from "../assets/Client/client18-fr.png";
import img20 from "../assets/Client/client-gas.png";

// Add more logos as needed
const clients = [img1, img2, img3,  img5, img6, img7, img9,img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20];

const ClientCarousel = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="py-3 text-center pb-4" data-aos="fade-up">
      <div className="container-fluid">
        <h3 className="fw-bold mb-2">Our Clients</h3>
        <p className="text-muted mb-4 client-para">
          We are proud to serve a diverse range of esteemed clients across various industries, <br />
          built on trust, quality, and long-term partnerships.
        </p>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={2}
          loop={true}
          autoplay={{ delay: 2000 }}
          breakpoints={{
            576: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            992: { slidesPerView: 5 },
            1200: { slidesPerView: 6 },
          }}
        >
          {clients.map((logo, idx) => (
            <SwiperSlide key={idx}>
              <img
                src={logo}
                alt={`Client ${idx}`}
                className="img-fluid p-2"
                style={{ height: "100px", objectFit: "contain" }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ClientCarousel;
